import { Injectable } from "@webmotors/ioc";
import { setMetadata } from "../common/metadata";

export function Query(name: string) {
  const decorator = Injectable(name);

  return (
    target: Function,
    _propertyName?: ClassDecoratorContext,
    _descriptor?: any
  ) => {
    decorator(target);
    setMetadata(target, "__QUERY__", {
      name,
    });
  };
}

export function QueryKey(target: any, propertyName: string, _descriptor?: any) {
  setMetadata(target, "__QUERY_KEY__", {
    propertyName,
  });
}

export function QueryFn(target: any, propertyName: string, _descriptor?: any) {
  setMetadata(target, "__QUERY_FN__", {
    propertyName,
  });
}
